import { render, staticRenderFns } from "./VxCardCustom.vue?vue&type=template&id=0b927332&"
import script from "./VxCardCustom.vue?vue&type=script&lang=js&"
export * from "./VxCardCustom.vue?vue&type=script&lang=js&"
import style0 from "./VxCardCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports